export default {
  notAllEnvelopesWereCalculated: 'Nie všetky obálky boli vypočítané',
  someEnvelopesAreInvalid: 'Niektoré obálky sú neplatné',
  commentRequiredNotPassed: 'Každá obálka, ktorá neprešla, vyžaduje komentár',
};
